import React from 'react';

const HowToPlayContentRO: React.FC = () => {
  return (
    <div className="space-y-4 text-gray-700">
      <div className="bg-blue-50 p-4 rounded-2xl">
        <h3 className="font-bold text-blue-800 mb-2">🎯 Obiectivul</h3>
        <p>Ghicește cine are ce număr uitându-te cum joacă!</p>
      </div>

      <div className="bg-green-50 p-4 rounded-2xl">
        <h3 className="font-bold text-green-800 mb-2">👥 Jucători</h3>
        <p>Aveți nevoie de 4-10 jucători. O persoană va fi "ghicitorul" iar ceilalți vor primi numere secrete de la 1-9.</p>
      </div>

      <div className="bg-orange-50 p-4 rounded-2xl">
        <h3 className="font-bold text-orange-800 mb-2">🎭 Cum să Joci</h3>
        <div className="space-y-2 text-sm">
          <p><strong>1.</strong> Ghicitorul citește o situație cu voce tare</p>
          <p><strong>2.</strong> Toți ceilalți mimează reacția lor pe baza numărului lor</p>
          <p><strong>3.</strong> Numărul 1 = foarte calm, Numărul 9 = complet nebun!</p>
          <p><strong>4.</strong> Ghicitorul observă și încearcă să descifreze cine are ce număr</p>
        </div>
      </div>

      <div className="bg-purple-50 p-4 rounded-2xl">
        <h3 className="font-bold text-purple-800 mb-2">🏆 Câștigarea</h3>
        <p>Ghicitorul primește puncte pentru fiecare ghicire corectă. Apoi altcineva devine noul ghicitor!</p>
      </div>

      <div className="bg-yellow-50 p-4 rounded-2xl">
        <h3 className="font-bold text-yellow-800 mb-2">💡 Exemplu</h3>
        <p className="text-sm"><strong>Situația:</strong> "Vezi un păianjen în camera ta"</p>
        <p className="text-sm">• Numărul 1: Rămâi calm, poate îl ignori</p>
        <p className="text-sm">• Numărul 9: Țipă și fugi!</p>
      </div>
    </div>
  );
};

export default HowToPlayContentRO;